// Клики WhatsApp и «Zəng et» у анкет карты (23.10.2026).
//
// Строку в map_contact_clicks пишет сервер — getPartnerPhone
// (map-public.functions.ts), в той же функции, что отдаёт номер. Здесь —
// значения и событие Google Analytics, которое шлёт браузер.
//
// Без серверных импортов: модуль читают кнопки карты и
// scripts/verify-map-contact-clicks.mts.
import { ev } from "@/components/home/home-events";

export const CONTACT_KINDS = ["whatsapp", "call"] as const;
export type ContactKind = (typeof CONTACT_KINDS)[number];

/** map — окошко метки и мини-карта главной, list — карточка в списке, profile — страница анкеты. */
export const CONTACT_SOURCES = ["map", "list", "profile"] as const;
export type ContactSource = (typeof CONTACT_SOURCES)[number];

/** Событие GA4 / Pixel. Без номера и без данных родителя. */
export function trackContactClick(kind: ContactKind, source: ContactSource, partnerId: string) {
  ev("map_contact_click", { contact_type: kind, source, tutor_id: partnerId });
}
